import React from "react";
import { BacktestingRunType } from "@shared/types";
import LineChart from "common/Charts/LineChart/LineChart";
import useBacktestingChart from "@shared/features/bots/BotForm/Backtesting/useBacktestingChart";
import Text from "common/Typography/Text";
import Checkbox from "common/Checkbox/Checkbox";
import useMedia from "utils/hooks/useMedia";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface BacktestingChartProps {
  backtestingRun?: BacktestingRunType;
}

const BacktestingChart = ({ backtestingRun }: BacktestingChartProps) => {
  const isSmallScreen = useMedia([`(max-width: 1000px)`], [true], false);
  const {
    lineChartMultiData,
    isFetching,
    isSuccess,
    displayCurrency,
    strXMinMax,
    displayCurrencyPrecision,
    includeInitialFundsData,
  } = useBacktestingChart({ backtestingRun });

  return (
    <LineChart
      multiData={lineChartMultiData}
      loading={isFetching}
      displayCurrency={displayCurrency}
      precision={displayCurrencyPrecision}
      isSuccess={isSuccess}
      xMax={strXMinMax?.max}
      xMin={strXMinMax?.min}
      extraLegendButton={
        <Checkbox
          onChange={(e: CheckboxChangeEvent) =>
            includeInitialFundsData.onChange(e.target.checked)
          }
          checked={includeInitialFundsData.checked}
        >
          <Text>{includeInitialFundsData.text}</Text>
        </Checkbox>
      }
      isSmallScreen={isSmallScreen}
    />
  );
};

export default BacktestingChart;
